import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import ArtworkUnit from "components/frame-designer/measure/ArtworkUnit";
import { Disclosure } from "@headlessui/react";

const MeasureContainer = (props) => {
  return (
    <MeasureUI
      image_id={props.image_id}
      paper_type_id={props.paper_type_id}
      presets={props.presets}
      next_path={props.next_path}
      max_artwork_long_mm={props.max_artwork_long_mm}
      max_artwork_short_mm={props.max_artwork_short_mm}
      img_help_1={props.img_help_1}
      img_help_2={props.img_help_2}
      mat_overlap={props.mat_overlap}
      frame_style_colour_id={props.frame_style_colour_id}
      hero_image={props.hero_image}
    />
  );
};

const unit_options = [
  { title: "mm", id: 0 },
  { title: "cm", id: 1 },
  { title: "in", id: 2 },
];

class MeasureUI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: "",
      height: "",
      width_mm: "",
      height_mm: "",
      unit: unit_options[0],
      unit_options: unit_options,
      max_w_or_h: 1020,
      min_w_or_h: 100,
      valid: true,
      presetsOpen: false,
      selectedPreset: null,
    };
    this.setWidth = this.setWidth.bind(this);
    this.setHeight = this.setHeight.bind(this);
    this.changeUnit = this.changeUnit.bind(this);
    this.saveValues = this.saveValues.bind(this);
    this.savePreset = this.savePreset.bind(this);
    this.validateAndSend = this.validateAndSend.bind(this);
    this.validate = this.validate.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.flipDimensions = this.flipDimensions.bind(this);
    this.togglePresets = this.togglePresets.bind(this);
    this.renderSizeButton = this.renderSizeButton.bind(this);
  }

  setWidth(e) {
    this.setState(
      { width: e.target.value },
      function () {
        this.updateDimensions();
      }.bind(this)
    );
  }

  setHeight(e) {
    this.setState(
      { height: e.target.value },
      function () {
        this.updateDimensions();
      }.bind(this)
    );
  }

  changeUnit(value) {
    this.setState(
      { unit: value },
      function () {
        this.updateDimensions();
      }.bind(this)
    );
  }

  saveValues(params) {
    this.setState(
      params,
      function () {
        this.updateDimensions();
        $(document).trigger("form:focusall", this.refs.form);
      }.bind(this)
    );
  }

  savePreset(preset) {
    console.log(preset);
    this.setState(
      {
        selectedPreset: preset,
        width: preset.width,
        height: preset.height,
        unit: this.state.unit_options.find((obj) => obj.title === preset.unit),
      },
      function () {
        this.updateDimensions();
        $(document).trigger("form:focusall", this.refs.form);
      }.bind(this)
    );
  }

  validateAndSend(e) {
    e.preventDefault();

    if (this.validate()) {
      this.setState({ isLoading: true });

      $.ajax({
        method: "PUT",
        url: this.props.next_path,
        data: {
          width: this.state.width,
          height: this.state.height,
          unit: this.state.unit.title,
          paper_type_id: this.props.paper_type_id,
          frame_style_colour_id: this.props.frame_style_colour_id,
        },
      }).done(
        function (data) {
          window.location.href = data.redirect_to;
        }.bind(this)
      );
    }
  }

  validate() {
    const { width_mm, height_mm } = this.state;
    const { max_artwork_long_mm, max_artwork_short_mm } = this.props;

    if (!this.state.width_mm || !this.state.height_mm) {
      this.setState({
        valid: false,
        message: "Have you entered a number for width and height?",
      });
      return false;
    } else if (
      Math.max(width_mm, height_mm) > max_artwork_long_mm ||
      Math.min(width_mm, height_mm) > max_artwork_short_mm
    ) {
      this.setState({
        valid: false,
        message: `Total size must be no greater than ${max_artwork_long_mm}x${max_artwork_short_mm}mm.`,
      });
      return false;
    } else if (
      width_mm < this.state.min_w_or_h ||
      height_mm < this.state.min_w_or_h
    ) {
      this.setState({
        valid: false,
        message: 'Each length must be no less than 10cm, 100mm or 4"',
      });
      return false;
    } else {
      this.setState({
        valid: true,
      });
      return true;
    }
  }

  updateDimensions() {
    var width = this.state.width;
    var height = this.state.height;
    var wmm = width;
    var hmm = height;
    if (this.state.unit.title == "cm") {
      wmm = width * 10;
      hmm = height * 10;
    } else if (this.state.unit.title == "in") {
      wmm = width * 25.4;
      hmm = height * 25.4;
    }
    this.setState(
      {
        width: width,
        height: height,
        width_mm: parseInt(wmm),
        height_mm: parseInt(hmm),
      },
      function () {
        if (this.state.valid == false) {
          this.validate();
        }
      }.bind(this)
    );
  }

  flipDimensions(e) {
    e.preventDefault();
    this.setState({
      width: this.state.height,
      height: this.state.width,
      width_mm: this.state.height_mm,
      height_mm: this.state.width_mm,
    });
  }

  togglePresets(e) {
    e.preventDefault();
    var active = !this.state.presetsOpen;
    this.setState({ presetsOpen: active });
  }

  renderSizeButton() {
    return (
      <a href="#" onClick={this.togglePresets} className="p-1 pt-3 block">
        Popular Sizes <i className="fa-solid fa-caret-down"></i>
      </a>
    );
  }

  render() {
    var classes = classNames(
      "btn btn-primary btn-lg  disabled:bg-stone-400 disabled:border-stone-400 disabled:text-white disabled:cursor-not-allowed"
    );

    var validation = this.state.valid ? (
      <button
        disabled={this.state.isLoading}
        onClick={this.validateAndSend}
        className={classes}
      >
        Next
        {this.state.isLoading ? (
          <i className="fa-solid fa-spinner fa-spin ml-2"></i>
        ) : (
          <i className="fa-solid fa-caret-right text-xs ml-2" />
        )}
      </button>
    ) : (
      <div className="text-red-800 bg-red-100 mb-2 p-5 rounded">
        {this.state.message}
      </div>
    );

    var reversable =
      this.state.width_mm && this.state.height_mm ? null : "disabled";

    var presets = this.state.presetsOpen && (
      <SizePresets
        presets={this.props.presets}
        savePreset={this.savePreset}
        selectedPreset={this.state.selectedPreset}
      />
    );
    return (
      <div className="grid md:grid-cols-2 mt-3 md:gap-x-12 max-w-7xl mx-auto">
        <div className="">
          <div className="md:pt-10 px-4">
            <h2 className="font-normal tracking-tight text-3xl md:text-5xl lg:text-3vw mb-8">
              Custom frames <br />— made to fit your artwork.
            </h2>
            <p>
              Custom frames tailored to your artwork and delivered to your door,
              complete with everything you need to fit your artwork and hang it.
            </p>

            <img src={this.props.hero_image} className="img-fluid mt-8" />
          </div>
        </div>
        <div className="pb-10 md:mt-6">
          <div className="mx-auto">
            <div className="w-full px-2 md:px-4 pt-2">
              <div className="mx-auto  mt-4 w-full max-w-xl rounded-lg bg-brand-100 p-3 md:p-4">
                <div className="mb-6">
                  <div
                    className="mx-3 floating-fields large-floating"
                    ref="form"
                  >
                    <h2 className="mb-2 text-3xl mb-3">
                      Step 1: Enter artwork measurements
                    </h2>

                    <div className="grid grid-cols-12">
                      <div className="col-span-12">
                        <div className="grid grid-cols-12 gap-x-2">
                          <div className="col-span-5">
                            <div className="form-group text-left m-0">
                              <label className="control-label" htmlFor="width">
                                Art Width (mm)
                              </label>
                              <input
                                className="form-control border-solid border border-stone-200"
                                onChange={this.setWidth}
                                value={this.state.width}
                                ref="width"
                                id="width"
                              />
                            </div>
                          </div>
                          <div className="col-span-2 text-center">
                            <a
                              href="#"
                              className={classNames(
                                reversable,
                                "p-2",
                                "btn",
                                "bg-stone-100",
                                "mt-3",
                                "no-underline"
                              )}
                              onClick={this.flipDimensions}
                            >
                              <i className="fa-solid fa-arrow-up-arrow-down fa-rotate-90"></i>
                            </a>
                          </div>
                          <div className="col-span-5">
                            <div className="form-group text-left m-0">
                              <label className="control-label" htmlFor="height">
                                Art Height (mm)
                              </label>
                              <input
                                className="form-control border-solid border border-stone-200"
                                onChange={this.setHeight}
                                value={this.state.height}
                                ref="height"
                                id="height"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {this.renderSizeButton()}
                    <div className="mb-3">{presets}</div>
                    <p className="alert alert-warning font-bold mb-6">
                      Note: Mat borders are cut with a{" "}
                      {this.props.mat_overlap / 2}mm overlap to ensure your
                      artwork fits.
                      {this.state.width_mm > this.state.min_w_or_h &&
                        this.state.height_mm > this.state.min_w_or_h && (
                          <span className=" bg-yellow-100 rounded p-1 px-2 ml-1">
                            Your mat window size will be{" "}
                            {this.state.width_mm - this.props.mat_overlap} x{" "}
                            {this.state.height_mm - this.props.mat_overlap}
                            mm
                          </span>
                        )}
                    </p>
                    <div className="mt-6">{validation}</div>
                  </div>
                </div>
                <div className="px-3 md:px-4 pb-4">
                  <h2 className="font-sans font-bold text-2xl text-stone-900 mb-3">
                    How to measure your artwork
                  </h2>
                  <h4 className="font-sans font-bold text-lg text-stone-900 mb-3">
                    1. Measuring a print with a paper margin
                  </h4>
                  <div className="mt-2 mb-5">
                    <video className="w-full " playsInline controls>
                      <source
                        src="https://cdn.shopify.com/videos/c/o/v/920e49e15a1743739190e9e537f2128b.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                  <h4 className="font-sans font-bold text-lg text-stone-900">
                    2. Measuring a print without a paper margin
                  </h4>
                  Simply enter the width and height of your print in millimeters
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class SizePresets extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      a_sizes: props.presets.a_sizes,
      metric_sizes: props.presets.metric_sizes,
      inches: props.presets.inches,
    };
    this.onSelect = this.onSelect.bind(this);
  }
  onSelect(radio) {
    this.props.savePreset(radio);
  }
  render() {
    return (
      <div className="my-3">
        <ArtworkUnit
          saveValues={this.onSelect}
          options={this.state.a_sizes}
          defaultChecked={this.props.selectedPreset}
        />
        <ArtworkUnit
          saveValues={this.onSelect}
          options={this.state.inches}
          defaultChecked={this.props.selectedPreset}
        />
      </div>
    );
  }
}

export default MeasureContainer;
